import { render } from "./MAMarketoForm.vue?vue&type=template&id=70e65b50&ts=true"
import script from "./MAMarketoForm.vue?vue&type=script&lang=ts"
export * from "./MAMarketoForm.vue?vue&type=script&lang=ts"

import "./MAMarketoForm.vue?vue&type=style&index=0&id=70e65b50&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__